// extracted by mini-css-extract-plugin
export var actionButton = "_72-1";
export var actionButtons = "_72-2";
export var actions = "_72-0";
export var aiUnread = "_72-10";
export var alignCenter = "_72-h";
export var backWrapper = "_72-3";
export var cellContainer = "_72-4";
export var checkboxContainer = "_72-5";
export var contentContainer = "_72-6";
export var contentHeader = "_72-8";
export var conversationsTableWrapper = "_72-s";
export var draftReplyBadgeContainer = "_72-m";
export var dropdownItem = "_72-b";
export var dropdownItemsContainer = "_72-a";
export var dropdownTitle = "_72-c";
export var errorIcon = "_72-7";
export var filter = "_72-d";
export var gray = "_72-i";
export var headerActionButtons = "_72-e";
export var headerCheckboxContainer = "_72-f";
export var icon = "_72-j";
export var menuContainer = "_72-k";
export var noMoreTicketsIcon = "_72-12";
export var noMoreTicketsSubText = "_72-13";
export var oneLine = "_72-l";
export var optionsButton = "_72-n";
export var plus = "_72-o";
export var portalButtonsWrapper = "_72-g";
export var red = "_72-p";
export var scrolledTop = "_72-9";
export var search = "_72-q";
export var selectedConversationsCount = "_72-r";
export var spinner = "_72-t";
export var strong = "_72-u";
export var summaryCell = "_72-v";
export var tableContainer = "_72-11";
export var tagContainer = "_72-w";
export var threeDots = "_72-x";
export var twoLines = "_72-y";
export var unread = "_72-z";